module.exports = __webpack_public_path__ + "media/images/icons/outlined/read-f713a585b06b0c84f5dac35e784eaaae.svg";